import Format from 'app/src/data/Format';
import SaleManager from 'app/src/payments/SaleManager';
import Terminal from 'app/src/payments/terminals/Terminal';
import { createReactRenderer } from 'helpers/react-renderer';
import Decimal from 'root/apps/app/src/data/base/Decimal';

import { TippingModal } from './TippingModal';
import { TippingReassignModal } from './TippingReassignModal';

// @ts-ignore no-unused-variable
let internalTipModalComponent = null;

interface TipCompleteParam {
  totalAmountWithTip: Decimal;
  tipAmount: Decimal;
}
export interface TippingModalProps {
  terminal?: Terminal | null;
  saleManager: SaleManager;
  transactionAmount: Decimal;
  tippableAmount: Decimal;
  onCancel: () => void;
  onTipComplete: (param: TipCompleteParam) => void;
}

export interface TipReAssignModalProps {
  saleManager: SaleManager;
  onCancel: () => void;
  currentSelectedEmployee: number;
  onTipReassignComplete: () => void;
}
export class TipModalWrapper {
  static startTipFlow({
    terminal,
    saleManager,
    transactionAmount,
    tippableAmount,
  }: TippingModalProps) {
    return new Promise<TipCompleteParam>((resolve, reject) => {
      const RenderedComponent = createReactRenderer({
        component: TippingModal,
        selector: '[data-react-root="ReactModal"]',
        props: {
          terminal,
          saleManager,
          transactionAmount,
          tippableAmount: tippableAmount ?? transactionAmount,
          onCancel: () => {
            internalTipModalComponent = null;
            RenderedComponent.unmount();
            reject();
          },
          onTipComplete: ({ tipAmount, totalAmountWithTip }: TipCompleteParam) => {
            internalTipModalComponent = null;
            RenderedComponent.unmount();
            resolve({ tipAmount, totalAmountWithTip });
          },
        },
      });
      internalTipModalComponent = RenderedComponent.mount();
    });
  }

  static startTipReAssignFlow({ saleManager }: TipReAssignModalProps) {
    return new Promise<void>((resolve, reject) => {
      const RenderedComponent = createReactRenderer({
        component: TippingReassignModal,
        selector: '[data-react-root="ReactModal"]',
        props: {
          saleManager,
          onCancel: () => {
            internalTipModalComponent = null;
            RenderedComponent.unmount();
            reject();
          },
          onTipReassignComplete: () => {
            internalTipModalComponent = null;
            RenderedComponent.unmount();
            // Push to GA
            window.dataLayer.push({
              event: `tip_reassign_receiptScreen`,
            });
            resolve();
          },
          currentSelectedEmployee: Format.parseInt(saleManager.sale.get('tipEmployeeID'), 0),
        },
      });
      internalTipModalComponent = RenderedComponent.mount();
    });
  }
}
